import React from 'react';
import { Grid, Card, CardContent, Skeleton, Box } from '@mui/material';

type SkeletonCardProps = {
    count: number;
};

const ArticleSkeletonCard: React.FC<SkeletonCardProps> = ({ count }) => {
    return (
        <Grid container spacing={3} sx={{ mt: 1 }}>
            {Array.from(new Array(count)).map((_, idx) => (
                <Grid item xs={12} sm={6} md={4} lg={3} xl={2} xxl={2} key={idx}>
                    <Card
                        className="box-shadow-center"
                        sx={{
                            cursor: 'pointer',
                            display: 'flex',
                            flexDirection: 'column',
                            height: '100%',
                            justifyContent: 'space-between',
                            borderRadius: "14px"
                        }}
                    >
                        <CardContent sx={{ position: 'relative', p: 0 }}>
                            <Skeleton variant="rectangular" height={200} sx={{ width: '100%' }} />
                            <Skeleton
                                variant="circular"
                                width={40}
                                height={40}
                                sx={{
                                    position: 'absolute',
                                    bottom: 15,
                                    left: 15,
                                }}
                            />
                        </CardContent>
                        <CardContent>
                            <Skeleton variant="text" width="80%" />
                            <Skeleton variant="text" />
                            <Skeleton variant="text" />
                        </CardContent>
                        <CardContent sx={{ flexGrow: 1, py: 0, display: 'flex', gap: 1 }}>
                            {Array.from(new Array(5)).map((_, i) => (
                                <Skeleton key={i} variant="text" width="20%" height="40px" />
                            ))}
                        </CardContent>
                        <CardContent sx={{ flexGrow: 1, py: 0, display: 'flex', gap: 1 }}>
                            {Array.from(new Array(5)).map((_, i) => (
                                <Skeleton key={i} variant="text" width="20%" height="40px" />
                            ))}
                        </CardContent>
                        <CardContent>
                            <Skeleton variant="text" width="40%" />
                        </CardContent>
                    </Card>
                </Grid>
            ))}
        </Grid>
    );
};

export default ArticleSkeletonCard;
